import { render } from "./FormPositionTraining.vue?vue&type=template&id=78779233&scoped=true&ts=true"
import script from "./FormPositionTraining.vue?vue&type=script&lang=ts"
export * from "./FormPositionTraining.vue?vue&type=script&lang=ts"

import "./FormPositionTraining.vue?vue&type=style&index=0&id=78779233&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78779233"]])

export default __exports__